import React from 'react'

import { SvgIconProps } from '@mui/material/SvgIcon'

import { ICON_DICTIONARY } from './icon-constants'

export type IconName = keyof typeof ICON_DICTIONARY

export type IconProps = Readonly<{
	name: IconName
	size?: number | string
	disabled?: boolean
}> &
	SvgIconProps

const DEFAULT_ICON_SIZE = 24

export default function Icon({
	name,
	size = DEFAULT_ICON_SIZE,
	disabled,
	...props
}: IconProps) {
	const IconComponent = ICON_DICTIONARY[name]

	if (!IconComponent) return null

	const iconProps = {
		...props,
		sx: {
			fontSize: size,
			width: size,
			height: size,
			...props.sx,
		},
	}

	return (
		<IconComponent
			{...iconProps}
			color={disabled ? 'disabled' : 'inherit'}
		/>
	)
}
